import { Component, Input, OnInit } from '@angular/core';
import { Comment } from '@app/interfaces/lm/project-task-comment';
interface FieldItem {
    label: string;
    key: string;
}
@Component({
    selector: 'app-view-dialog',
    templateUrl: './view-dialog.component.html',
    styleUrls: ['./view-dialog.component.less'],
})
export class ViewDialogComponent implements OnInit {
    @Input() title = 'View';
    @Input() labelSpan = 6;
    @Input() fields: FieldItem[] = [];
    isVisible = false;
    data: Comment = {} as Comment;

    constructor() {
    }

    ngOnInit(): void {
    }

    close(): void {
        this.isVisible = false;
    }


    open(row: Comment): void {
        this.isVisible = true;
        this.data = row;
        console.log('a', this.fields, row);
    }

}
